// src/components/Home/AutomationsWidget.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";

const AutomationsWidget = ({ automations }) => {
  const navigate = useNavigate();

  if (!automations) {
    return (
      <div className="dashboard-widget">
        < FullScreenLoader message="Carregando Automações..." />
      </div>
    );
  }

  const getStatusColor = (status) => {
    switch (status) {
      case "COMPLETED":
        return "#2ecc71";
      case "RUNNING":
        return "#f39c12";
      case "FAILED":
        return "#e74c3c";
      default:
        return "#95a5a6";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "COMPLETED":
        return "✓";
      case "RUNNING":
        return "⟳";
      case "FAILED":
        return "✗";
      default:
        return "○";
    }
  };

  return (
    <div className="dashboard-widget">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
        <h3 style={{ margin: 0 }}>Automações Ativas</h3>
        <span style={{ fontSize: "24px", fontWeight: "bold", color: "#2ecc71" }}>
          {automations.total_active}
        </span>
      </div>

      <p style={{ color: "#7f8c8d", fontSize: "14px", marginBottom: "15px" }}>
        {automations.executions_today} execuções hoje
      </p>

      <div style={{ marginBottom: "15px" }}>
        <h4 style={{ fontSize: "14px", marginBottom: "10px", color: "#7f8c8d" }}>
          Execuções recentes:
        </h4>
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {automations.recent_executions && automations.recent_executions.slice(0, 5).map((exec) => (
            <div
              key={exec.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px",
                background: "var(--bg-tertiary",
                borderRadius: "4px",
                fontSize: "13px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span
                  style={{
                    color: getStatusColor(exec.status),
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {getStatusIcon(exec.status)}
                </span>
                <span>{exec.status}</span>
              </div>
              <span style={{ color: "#95a5a6", fontSize: "12px" }}>
                {new Date(exec.started_at).toLocaleTimeString()}
              </span>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={() => navigate("/automations")}
        style={{
          width: "100%",
          padding: "8px",
          background: "transparent",
          border: "1px solid #2ecc71",
          borderRadius: "4px",
          color: "#2ecc71",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        Ver todas Automações →
      </button>
    </div>
  );
};

export default AutomationsWidget;
